// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"5b7b5d35","763":"96218351"}[chunkId] + ".chunk.js";
};